// const Col = React.lazy(() => import('./Col'));
// const Row = React.lazy(() => import('./Row'));
// const Container = React.lazy(() => import('./Container'));
// const Header = React.lazy(() => import('./Header'));
// const Heading = React.lazy(() => import('./Heading'));
// const Navbar = React.lazy(() => import('./Navbar'));
// const Footer = React.lazy(() => import('./Footer'));

import React from "react";

import Col from "./Col";
import Row from "./Row";
// import Container from './Container'
import Header from "./Header";
import Heading from "./Heading";
import Navbar from "./Navbar";
import Footer from "./Footer";
const Text = React.lazy(() => import("./Text"));

// import AdminPageFullScreen from './AdminPageFullScreen'
// import AdminPageWithMenu from './AdminPageWithMenu'
const KPI = React.lazy(() => import("./KPI"));

const Input = React.lazy(() => import("./Input"));

const Search = React.lazy(() => import("./Search"));

// import CategorySearch from './CategorySearch'
import Content from "./Content";

import Section from "./Section";

import PageTypeAdmin from "./PageTypeAdmin";
import PageTypeForm from "./PageTypeForm";

const Radio = React.lazy(() => import("./Radio"));

const Checkbox = React.lazy(() => import("./Checkbox"));

const Dropdown = React.lazy(() => import("./Dropdown"));

const Panel = React.lazy(() => import("./Panel"));

const Button = React.lazy(() => import("./Button"));

const Error = React.lazy(() => import("./Error"));

const FormTab = React.lazy(() => import("./FormTab"));

const Form = React.lazy(() => import("./Form"));

const ProcessButtons = React.lazy(() => import("./ProcessButtons"));

const Login = React.lazy(() => import("./Login"));

const Cards = React.lazy(() => import("./Cards"));

const ProcessBar = React.lazy(() => import("./ProcessBar"));

const Password = React.lazy(() => import("./Password"));

const Table = React.lazy(() => import("./Table"));

const SectionIndicator = React.lazy(() => import("./SectionIndicator"));

const FileUpload = React.lazy(() => import("./FileUpload"));

const Articles = React.lazy(() => import("./Articles"));

const Markdown = React.lazy(() => import("./Markdown"));

const EffectTable = React.lazy(() => import("./EffectTable"));

const GoogleMaps = React.lazy(() => import("./GoogleMaps"));

const FacebookLogin = React.lazy(() => import("./FacebookLogin"));

const OpenIdConnect = React.lazy(() => import("./OpenIdConnect"));

const GrandId = React.lazy(() => import("./GrandId"));

const Image = React.lazy(() => import("./Image"));

const Todos = React.lazy(() => import("./Todos"));

const Categories = React.lazy(() => import("./Categories"));

const EffectList = React.lazy(() => import("./EffectList"));

// import CategoryFormList from './CategoryFormList'
const Summary = React.lazy(() => import("./Summary/index.js"));

const Signature = React.lazy(() => import("./Signature"));

const FormLabel = React.lazy(() => import("./FormLabel"));

const Notifications = React.lazy(() => import("./Notifications"));

const ConfirmBtns = React.lazy(() => import("./ConfirmBtns"));

const Stop = React.lazy(() => import("./Stop"));

import SAML from "./SAML";
const Lookup = React.lazy(() => import("./Lookup"));

// const Process = React.lazy(() => import("./Process"));

const InlineHTML = React.lazy(() => import("./InlineHTML"));

const InputTable = React.lazy(() => import("./InputTable"));

const ProcessList = React.lazy(() => import("./ProcessList"));

const ChildSelector = React.lazy(() => import("./ChildSelector"));

const SecondGuardian = React.lazy(() => import("./SecondGuardian"));

const NotificationsPopup = React.lazy(() => import("./NotificationsPopup"));

const GrandIdSignature = React.lazy(() => import("./GrandIdSignature"));

const GRPSignature = React.lazy(() => import("./GRPSignature"));

const OLMap = React.lazy(() => import("./OLMap"));

const Profile = React.lazy(() => import("./Profile"));

const Logout = React.lazy(() => import("./Logout"));

const SignatureInfo = React.lazy(() => import("./SignatureInfo"));

const Booking = React.lazy(() => import("./Booking"));

const EffectCard = React.lazy(() => import("./EffectCard"));

const Clone = React.lazy(() => import("./Clone"));

// import ResetPassword from './ResetPassword'
const EventBooking = React.lazy(() => import("./EventBooking"));

const Effect = React.lazy(() => import("./Effect"));

const QueueInfo = React.lazy(() => import("./QueueInfo"));

const SwedbankPay = React.lazy(() => import("./SwedbankPay"));

const ResetPassword = React.lazy(() => import("./ResetPassword"));

const BankID = React.lazy(() => import("./BankID"));

const BankIDSignature = React.lazy(() => import("./BankIDSignature"));

const PaymentStatus = React.lazy(() => import("./PaymentStatus"));

const Vote = React.lazy(() => import("./Vote"));

const FormTodo = React.lazy(() => import("./FormTodo"));

const Location = React.lazy(() => import("./Location"));

const RiskMatrix = React.lazy(() => import("./RiskMatrix"));

const Repeat = React.lazy(() => import("./Repeat"));

const Accordion = React.lazy(() => import("./Accordion"));

const Receipt = React.lazy(() => import("./Receipt"));

const FormCards = React.lazy(() => import("./FormCards"));

const FormCreate = React.lazy(() => import("./FormCreate"));

const StateGroups = React.lazy(() => import("./StateGroups"));
const NotificationsHub = React.lazy(() => import("./NotificationsHub"));
const PDF = React.lazy(() => import("./PDF"));
const Chart = React.lazy(() => import("./Chart"));
const Date = React.lazy(() => import("./Date"));
const Tickets = React.lazy(() => import("./Tickets"));
const GroupSelector = React.lazy(() => import("./GroupSelector"));
const IDPHub = React.lazy(() => import("./IDPHub"));
const Datasheet = React.lazy(() => import("./Datasheet"));
const Loader = React.lazy(() => import("./Loader"));
const CRUD = React.lazy(() => import("./CRUD"));
const ProcessOverview = React.lazy(() => import("./ProcessOverview"));
const LinkIcons = React.lazy(() => import("./LinkIcons"));
const RadioIcons = React.lazy(() => import("./RadioIcons"));

// import Carousel from './Carousel'

// import Service from './Service'

// import PageTypeViewTemplate from './PageTypeViewTemplate'

import withWrapper from "./withWrapper";

const components = {
  Col: withWrapper(Col, { noWrap: true }),
  Row: withWrapper(Row, { noWrap: true }),
  Header: withWrapper(Header, { noWrap: true }),
  Navbar: withWrapper(Navbar, { noWrap: true }),
  Heading,
  Footer,
  Text: withWrapper(Text, { className: "sp-text", hasSummary: true }),
  KPI,
  Input: withWrapper(Input, { className: "sp-input", hasSummary: true }),
  Search,
  Content,
  Section,
  PageTypeAdmin,
  PageTypeForm,
  Booking: withWrapper(Booking, { className: "sp-booking", hasSummary: true }),
  Radio: withWrapper(Radio, { className: "sp-radio", hasSummary: true }),
  Checkbox: withWrapper(Checkbox, {
    className: "sp-checkbox",
    hasSummary: true,
  }),
  Dropdown: withWrapper(Dropdown, {
    className: "sp-dropdown",
    hasSummary: true,
  }),
  Panel,
  Button: withWrapper(Button, {
    className: "sp-button",
    hasSummary: false,
    noWrap: true,
  }),
  Error,
  Date: withWrapper(Date, { className: "sp-date", hasSummary: true }),
  Form,
  FormTab: withWrapper(FormTab, { noWrap: true }),
  ProcessButtons,
  Login,
  Tickets: withWrapper(Tickets, { className: "sp-tickets", hasSummary: false }),
  Cards,
  ProcessBar,
  Password: withWrapper(Password, {
    className: "sp-password",
    hasSummary: true,
  }),
  Table: withWrapper(Table, { className: "sp-table", hasSummary: true }),
  SectionIndicator,
  Chart,
  FileUpload,
  Articles,
  Markdown,
  EffectTable: withWrapper(EffectTable, {
    className: "sp-effect-table",
    hasSummary: true,
  }),
  GoogleMaps,
  FacebookLogin,
  OpenIdConnect,
  GrandId,
  Image,
  Todos,
  Categories,
  EffectList,
  // CategoryFormList,
  PDF,
  Summary: withWrapper(Summary, { className: "sp-summary", hasSummary: false }),
  Signature,
  FormLabel,
  Notifications,
  ConfirmBtns,
  Lookup: withWrapper(Lookup, { className: "sp-lookup" }),
  SAML,
  IDPHub,
  // Process,
  NotificationsPopup,
  ChildSelector: withWrapper(ChildSelector, {
    className: "sp-child-selector",
    noMargin: false,
  }),
  SecondGuardian: withWrapper(SecondGuardian, {
    className: "sp-second-guardian",
  }),
  InlineHTML,
  InputTable,
  ProcessList: withWrapper(ProcessList, { className: "sp-process-list" }),
  Stop,
  NotificationsHub,
  GrandIdSignature,
  GRPSignature,
  OLMap,
  Profile,
  Logout,
  SignatureInfo,
  EffectCard: withWrapper(EffectCard, { className: "sp-effect-card" }),
  Clone,
  // ResetPassword,
  EventBooking,
  Effect,
  QueueInfo,
  BankID,
  BankIDSignature,
  SwedbankPay,
  ResetPassword,
  PaymentStatus,
  Vote,
  FormTodo,
  Location: withWrapper(Location, { className: "sp-location" }),
  RiskMatrix,
  Repeat: withWrapper(Repeat, { className: "sp-repeat" }),
  Accordion: withWrapper(Accordion, { className: "sp-accordion" }),
  Receipt,
  FormCards: withWrapper(FormCards, { className: "sp-form-cards" }),
  FormCreate: withWrapper(FormCreate, { className: "sp-form-create" }),
  StateGroups,
  GroupSelector,
  Datasheet,
  Loader,
  CRUD,
  ProcessOverview,
  LinkIcons,
  RadioIcons,
  // Carousel
  // Service

  // PageTypeViewTemplate
};

export default components;
